"use client";

import React from "react";
import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import Translations from "@translate/components/Portfolio/Header/TodayGain/TodayGain";
import { I18nUtil } from "@utils/i18n";
import { useIsPc } from "@/src/hooks";

const I18n = I18nUtil.createScoped(Translations);

export interface TodayGainProps {
  /** 今日涨跌幅 */
  todayGain?: { text: string; isUp: boolean };
  /** 右侧说明文案，例如 24H Performance */
  /** 额外类名 */
  className?: string;
}

export const TodayGain: React.FC<TodayGainProps> = ({
  todayGain,
  className,
}) => {
  const [isPc] = useIsPc();

  return (
    <div className={cn("flex gap-1 items-center", className)}>
      <div className="flex gap-[2px] items-center">
        {!!todayGain?.text && (
          <Icon
            name={todayGain?.isUp ? "upvote" : "downvote"}
            size={isPc ? 12 : 10}
            className={cn({
              "text-content_accent1_primary": todayGain?.isUp,
              "text-content_accent2_primary": !todayGain?.isUp,
            })}
          />
        )}
        {!!todayGain?.text ? (
          <span
            className={cn("md:body_medium_m body_medium_s", {
              "text-content_accent1_primary": todayGain?.isUp,
              "text-content_accent2_primary": !todayGain?.isUp,
            })}
          >
            {todayGain?.text}
          </span>
        ) : (
          <span className="md:body_medium_m body_medium_s text-content_quaternary">
            --
          </span>
        )}
      </div>
      <span className="body_s text-content_quaternary">
        {I18n.t("24H Performance")}
      </span>
    </div>
  );
};
